import { getSuggestedDraftsStore } from "../store/store";
import { buildSuggestedDraftsKey } from "../utils/buildSuggestedDraftsKey";

export function getSuggestedDraftTexts(conversationId: string, itemId: string, addinTitleId: string): string[] | undefined {
    if (!conversationId && !itemId) {
        return undefined;
    }
    
    const key = buildSuggestedDraftsKey(conversationId, itemId, addinTitleId);
    const entry = getSuggestedDraftsStore().suggestedDraftsMap.get(key);
    return entry?.suggestions;
}
